import $ from "jquery";
AOS.init();
document.addEventListener("DOMContentLoaded", function () {
    const toggle = document.querySelector('.newsFilter > .row > .col-6 > .order');
    const arrow = document.querySelector('.newsFilter > .row > .col-6 > .order > svg');

    if (toggle) {
        toggle.addEventListener("click", function () {
            const url = new URL(window.location.href);
            const current = url.searchParams.get("order") || "desc";
            const next = current === "asc" ? "desc" : "asc";
            url.searchParams.set("order", next);
            window.location.href = url.toString();
        });

        // 初始化箭頭方向
        const current = new URL(window.location.href).searchParams.get("order") || "desc";
        if (current === "asc") {
            arrow.classList.add("asc");
        } else {
            arrow.classList.remove("asc");
        }
    }
});


document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.tagFilter');          // 🔸外層
    const panelBtn = document.querySelector('.tagFilterToggle');
    const panel = document.querySelector('.tagFilterPanel');
    const checks = document.querySelectorAll('.tagFilterChk');
    const results = document.querySelector('.articleGrid');
    const totalEl = document.getElementById('total-count');
    const chipsBox = document.getElementById('selected-chips');
    const orderBtns = document.querySelectorAll('.orderBtn');
    if (!results) return;

    // 🔸小工具
    const isOpen = () => panel && panel.hasAttribute('hidden') === false;
    const setOpen = (open) => {
        if (!panel || !panelBtn) return;
        if (open) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
        panelBtn.setAttribute('aria-expanded', String(open));
    };

    // 開關下拉（沿用你的寫法但改用 setOpen）
    panelBtn && panelBtn.addEventListener('click', () => setOpen(!isOpen()));

    // 🔸點外面就關（用 pointerdown 手感更接近原生 select）
    document.addEventListener('pointerdown', (e) => {
        if (!isOpen()) return;                     // 已關就不處理
        if (wrapper && wrapper.contains(e.target)) return; // 點在元件內部不關
        setOpen(false);
    });

    // 🔸按 Esc 關閉
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen()) setOpen(false);
    });

    // （以下保留你的原程式）
    const url = new URL(window.location.href);
    const initialTags = (url.searchParams.get('tags') || '').split(',').map(x => parseInt(x, 10)).filter(Boolean);
    const initialOrder = (url.searchParams.get('order') || 'desc').toLowerCase();
    const initialPaged = parseInt(url.searchParams.get('paged') || '1', 10);

    if (initialTags.length) checks.forEach(c => { if (initialTags.includes(parseInt(c.value, 10))) c.checked = true; });
    orderBtns.forEach(b => b.classList.toggle('is-active', b.dataset.order === initialOrder));

    function renderChips(list) {
        chipsBox.innerHTML = '';
        list.forEach(({ id, name }) => {
            const btn = document.createElement('button');
            btn.className = 'chip';
            btn.dataset.id = id;
            btn.innerHTML = `${name}<span class="x" aria-hidden="true">×</span>`;
            btn.addEventListener('click', () => {
                const chk = document.querySelector(`.tagFilterChk[value="${id}"]`);
                if (chk) { chk.checked = false; onChange(); }
            });
            chipsBox.appendChild(btn);
        });
    }

    function fetchAndRender(selectedIds, orderVal, paged = 1) {
        const u = new URL(window.location.href);
        if (selectedIds.length) u.searchParams.set('tags', selectedIds.join(','));
        else u.searchParams.delete('tags');
        u.searchParams.set('order', orderVal);
        u.searchParams.set('paged', String(paged));
        window.history.replaceState({}, '', u.toString());

        const body = new URLSearchParams({
            action: 'filter_posts_by_tags',
            nonce: WP_TAG_FILTER.nonce,
            tags: selectedIds.join(','),
            order: orderVal,
            paged: String(paged)
        });

        fetch(WP_TAG_FILTER.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body
        })
            .then(r => r.json())
            .then(data => {
                if (!data.success) throw new Error();
                results.innerHTML = data.data.html + data.data.pagination;
                if (totalEl) totalEl.textContent = data.data.total;
                renderChips(data.data.selected);
                results.scrollIntoView({ behavior: 'instant', block: 'start' });
            })
            .catch(() => { results.innerHTML = '<p>發生錯誤，請重試。</p>'; });
    }

    function onChange() {
        const selected = Array.from(checks).filter(chk => chk.checked).map(chk => chk.value);
        const orderVal = (new URL(window.location.href)).searchParams.get('order') || 'desc';
        fetchAndRender(selected, orderVal, 1);
    }

    checks.forEach(chk => chk.addEventListener('change', onChange));

    orderBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            orderBtns.forEach(b => b.classList.remove('is-active'));
            btn.classList.add('is-active');
            const selected = Array.from(checks).filter(chk => chk.checked).map(chk => chk.value);
            fetchAndRender(selected, btn.dataset.order, 1);
        });
    });

    results.addEventListener('click', e => {
        const a = e.target.closest('.pagination a.page-link');
        if (!a) return;
        e.preventDefault();
        const page = parseInt(a.dataset.page, 10);
        const selected = Array.from(checks).filter(chk => chk.checked).map(chk => chk.value);
        const orderVal = (new URL(window.location.href)).searchParams.get('order') || 'desc';
        fetchAndRender(selected, orderVal, page);
    });

    if (initialTags.length || initialPaged > 1 || initialOrder !== 'desc') {
        fetchAndRender(initialTags, initialOrder, initialPaged);
    }
});